import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg3Dot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 5.5,
			r: 1.5,
			fill: "var(--color-black)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 11.5,
			r: 1.5,
			fill: "var(--color-black)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 17.5,
			r: 1.5,
			fill: "var(--color-black)"
		})
	]
});
export default Svg3Dot;
